module.exports = __webpack_public_path__ + "img/alert.c39d4c43.png";